import * as Sentry from "@sentry/react";
import { pushGtmEvent } from "@/lib/analytics";

export function track(event: string, props: Record<string, any> = {}) {
  pushGtmEvent(event, props as Record<string, unknown>);
  try {
    Sentry.addBreadcrumb({
      category: "bulk_order",
      message: event,
      level: "info",
      data: props,
    });
  } catch {
    // no-op
  }
  try {
    // Optional dev visibility
    if ((import.meta as any)?.env?.DEV) {
      // eslint-disable-next-line no-console
      console.log("[track]", event, props);
    }
  } catch {}
}

